<template>
  <div class="new_toc_v23">
    <div class="toc_section">
      <div class="toc_ic_container">
        <button class="btn btn_toc" @click="activateToc" title="show Table Of Contents">
          <span class="ic22-btnToC"></span>
        </button>
      </div>
      <div class="toc_container" :class="isTocOpen ? 'active' : ''">
        <div class="toc_hd">
          <div class="toc_hd_tx" role="heading" aria-level="2">Table of Contents</div>
          <div class="toc_hd_btn">
            <button class="btn_ic btn_close" @click="deActivateToc" aria-label="close table of contents section">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div class="toc_content">
          <table-of-contents ref="toc"></table-of-contents>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import TableOfContents from './TableOfContents'

export default {
  name: 'table-of-contents-wrapper',
  props: [],
  components: {
    TableOfContents
  },
  data: () => {
    return {
    }
  },

  created () {
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'updateIsTocOpen'
    ]),
    activateToc () {
			this.updateIsTocOpen(true)
		},
		deActivateToc () {
			this.updateIsTocOpen(false)
		}
  },

  computed: {
    ...mapState({
      'isTocOpen': state => state.course.isTocOpen,
    })
  },

  watch: {
  }
}
</script>

<style lang="scss">
@import '../../../assets/theme/default/sass/mixin';
@import '../../../assets/theme/default/sass/colors';
@import '../../../assets/module/sass/course/toc.scss';
</style>



// WEBPACK FOOTER //
// src/app/course/components/TableOfContentsWrapper.vue